import React from 'react';
import { Select } from 'antd';
import moment from 'moment';

const Option = Select.Option;

export function hasErrors(fieldsError) {
  console.warn('errore nella form:', fieldsError);
  return Object.keys(fieldsError).some(field => fieldsError[field]);
}

export function createOptions(coll) {
  if (coll && coll.length > 0) {
    return coll.map(formaDid => (
      <Option
        key={formaDid.idFormaDidattica}
        value={formaDid.idFormaDidattica}
      >{formaDid.descrizione}
      </Option>));
  }
  return;
}

export function generateRange(regYear, regCDL, regOccs, dateClose) {
  const range = {
    minDate: moment(),
    maxDate: moment(),
  };
  regCDL = (regCDL == null ? '' : regCDL.toUpperCase());
  switch (regCDL) {
  case 'CDLTRI':
  case 'CDLMAGCU':
  case 'CDLMAG':
    // case 'DOTT':
    range.minDate.year(regYear - 1);
    range.minDate.month(8);
    range.minDate.date(1);
    range.minDate.hours(0);
    range.minDate.minutes(0);
    range.minDate.second(0);
    range.maxDate.year(regYear);
    range.maxDate.month(9);
    range.maxDate.date(30);
    range.maxDate.hours(23);
    range.maxDate.minutes(59);
    range.maxDate.second(0);
    break;
  case 'DOTT':
  case 'SCSPVET':
    range.minDate.year(regYear - 1);
    range.minDate.month(8);
    range.minDate.date(1);
    range.minDate.hours(0);
    range.minDate.minutes(0);
    range.minDate.second(0);
    range.maxDate.year(regYear);
    range.maxDate.month(8);
    range.maxDate.date(30);
    range.maxDate.hours(23);
    range.maxDate.minutes(59);
    range.maxDate.second(0);
    break;
  case 'OFFLIBERA':
  case 'SCSPECU':
    // case 'SCSPVET':
    range.minDate.year(regYear - 1);
    range.minDate.month(8);
    range.minDate.date(1);
    range.minDate.hours(0);
    range.minDate.minutes(0);
    range.minDate.second(0);
    range.maxDate.year(regYear);
    range.maxDate.month(7);
    range.maxDate.date(31);
    range.maxDate.hours(23);
    range.maxDate.minutes(59);
    range.maxDate.second(0);
    break;
  case 'FOR24':
  case 'SOSTEGNO':
    range.minDate.year(regYear - 1);
    range.minDate.month(9);
    range.minDate.date(0);
    range.minDate.hours(0);
    range.minDate.minutes(0);
    range.minDate.second(0);
    range.maxDate.year(regYear + 1);
    range.maxDate.month(0);
    range.maxDate.date(31);
    range.maxDate.hours(23);
    range.maxDate.minutes(59);
    range.maxDate.second(0);
    break;
  case 'SCSPSAN':
    range.minDate.year(regYear);
    range.minDate.month(0);
    range.minDate.date(1);
    range.minDate.hours(0);
    range.minDate.minutes(0);
    range.minDate.second(0);
    range.maxDate.year(regYear + 1);
    range.maxDate.month(11);
    range.maxDate.date(31);
    range.maxDate.hours(23);
    range.maxDate.minutes(59);
    range.maxDate.second(0);
    break;
  case 'MAS1LIV':
  case 'MAS2LIV':
    range.minDate.year(regYear - 1);
    range.minDate.month(8);
    range.minDate.date(1);
    range.minDate.hours(0);
    range.minDate.minutes(0);
    range.minDate.second(0);
    range.maxDate.year(regYear + 1);
    range.maxDate.month(8);
    range.maxDate.date(30);
    range.maxDate.hours(23);
    range.maxDate.minutes(59);
    range.maxDate.second(0);
    break;
  case 'MASU1LIV':
  case 'MASU2LIV':
    range.minDate.year(regYear - 1);
    range.minDate.month(10);
    range.minDate.date(1);
    range.minDate.hours(0);
    range.minDate.minutes(0);
    range.minDate.second(0);
    range.maxDate.year(regYear + 1);
    range.maxDate.month(2);
    range.maxDate.date(30);
    range.maxDate.hours(23);
    range.maxDate.minutes(59);
    range.maxDate.second(0);
    break;
  case 'CORPERF':
    range.minDate.year(regYear - 1);
    range.minDate.month(8);
    range.minDate.date(1);
    range.minDate.hours(0);
    range.minDate.minutes(0);
    range.minDate.second(0);
    range.maxDate.year(regYear);
    range.maxDate.month(11);
    range.maxDate.date(31);
    range.maxDate.hours(23);
    range.maxDate.minutes(59);
    range.maxDate.second(0);
    break;
  default:
    range.minDate.year(regYear - 2);
    range.minDate.month(8);
    range.minDate.date(1);
    range.minDate.hours(0);
    range.minDate.minutes(0);
    range.minDate.second(0);
    range.maxDate.year(regYear + 1);
    range.maxDate.month(11);
    range.maxDate.date(31);
    range.maxDate.hours(23);
    range.maxDate.minutes(59);
    range.maxDate.second(0);
  }
  if (regOccs && regOccs.length > 0) {
    const lastOcc = regOccs[regOccs.length - 1];
    // console.warn('ultima data trovata:', lastOcc.data);
    range.minDate = ( range.minDate.isBefore(lastOcc.data) ? lastOcc.data : range.minDate );
  }
  if (dateClose) {
    range.maxDate = moment(dateClose);
  }
  // console.warn('generato range date:', range);
  return range;
}
